var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('CustomerCreditCardItem',{attrs:{"card":_vm.savedCard,"label":"最新の登録内容"}}),_c('CustomerCreditCardItem',{attrs:{"card":_vm.previousCard,"label":"前回の登録内容"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }